import { render, staticRenderFns } from "./baseUpload.vue?vue&type=template&id=0b6b6e59&scoped=true&"
import script from "./baseUpload.vue?vue&type=script&lang=js&"
export * from "./baseUpload.vue?vue&type=script&lang=js&"
import style0 from "./baseUpload.vue?vue&type=style&index=0&id=0b6b6e59&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6b6e59",
  null
  
)

export default component.exports